import { MutationObserverOptions, useMutation } from 'react-query';

import { IsetOutRoiInput, IsetOutRoiOutput, queryClient, setOutRoi } from 'clients/api';
import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

type Options = MutationObserverOptions<
    IsetOutRoiOutput,
  Error,
  Omit<IsetOutRoiInput, 'dlControllerContract'>
>;

const useSetOutRoi = (options?: Options) => {
  const dlControllerContract = useDlVaultContract();

  return useMutation(
    FunctionKey.SET_OUT_ROI,
    (params: Omit<IsetOutRoiInput, 'dlControllerContract'>) =>
        setOutRoi({
          dlControllerContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        // Invalidate queries related to fetching the user minted VAI amount
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_USERINFO);
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useSetOutRoi;
